import React from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    Typography,
    Divider,
} from '@mui/material';
import { styled } from "@mui/material/styles";
import PageLoadingSkeleton from '../skeletons/PageLoadingSkeleton';


const StyledTypography = styled(Typography)`
color: ${({ theme }) => theme.palette.primary.contrastText};
font-weight: bold;
`;

export default function Summary(props) {
    // const [summaryData, setSummaryData] = useState(null)
    const { data } = props

    if (data === null) return <PageLoadingSkeleton variant={"rectangular"} marginx={0} marginy={0} count={1} height={500} />

    return (
        <Card>

            <StyledTypography
                align="center"
                color="textPrimary"
                variant="h2"
            >
                {data}
            </StyledTypography>
            <CardHeader
                subheader={data}
                title={data}
            />

            <Divider />
            <CardContent>

                {/* <JSONToTable data={data} keysToExclude={["id", "__typename"]} /> */}

            </CardContent>
        </Card>

    );
}




